// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PendingOrdersSection_pending-orders-link__vlQqr {
  display: block;
  max-width: 117rem;
  margin: 10rem auto 7rem;
  border-radius: 1.1rem;
  background: var(--weekly-bonus-gradient);
  height: 13rem;
  display: flex;
  justify-content: center;
  gap: 4rem;
  align-items: center;
  position: relative;
}

.PendingOrdersSection_pending-orders-link__text__4EkjV {
  color: #000;
  font-size: var(--text-xl);
  font-weight: 700;
  line-height: 2.1rem;
}

.PendingOrdersSection_pending-orders-link__icon__nk014 {
  width: 4rem;
  height: 4rem;
  object-fit: contain;
}

.PendingOrdersSection_pending-orders-link__image__0kbPf {
  position: absolute;
  right: 0;
  bottom: 0;
}

.PendingOrdersSection_pending-orders-link__mtor-vector__6qRPM {
  position: absolute;
  left: 4rem;
  top: 0;
  height: 100%;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .PendingOrdersSection_pending-orders-link__vlQqr {
    max-width: 80rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/PendingOrdersSection/PendingOrdersSection.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".pending-orders-link {\n  display: block;\n  max-width: 117rem;\n  margin: 10rem auto 7rem;\n  border-radius: 1.1rem;\n  background: var(--weekly-bonus-gradient);\n  height: 13rem;\n  display: flex;\n  justify-content: center;\n  gap: 4rem;\n  align-items: center;\n  position: relative;\n}\n\n.pending-orders-link__text {\n  color: #000;\n  font-size: var(--text-xl);\n  font-weight: 700;\n  line-height: 2.1rem;\n}\n\n.pending-orders-link__icon {\n  width: 4rem;\n  height: 4rem;\n  object-fit: contain;\n}\n\n.pending-orders-link__image {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.pending-orders-link__mtor-vector {\n  position: absolute;\n  left: 4rem;\n  top: 0;\n  height: 100%;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .pending-orders-link {\n    max-width: 80rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pending-orders-link": `PendingOrdersSection_pending-orders-link__vlQqr`,
	"pending-orders-link__text": `PendingOrdersSection_pending-orders-link__text__4EkjV`,
	"pending-orders-link__icon": `PendingOrdersSection_pending-orders-link__icon__nk014`,
	"pending-orders-link__image": `PendingOrdersSection_pending-orders-link__image__0kbPf`,
	"pending-orders-link__mtor-vector": `PendingOrdersSection_pending-orders-link__mtor-vector__6qRPM`
};
export default ___CSS_LOADER_EXPORT___;
